import client from '../client';
export default {
  getCampaigns: data => {
    return client.get('seller/placement/campaigns/list', { params: data }).then(res => res.data);
  },
  getCampaignsEarnings: data => {
    return client.get('seller/placement/campaigns/earnings', { params: data }).then(res => res.data);
  },
  getCampaignsDetail: data => {
    return client.get(`seller/placement/campaigns/${data.campaignId}/detail`, { params: data }).then(res => res.data);
  },
 suspendCampaign: data => {
  return client.post(`seller/placement/campaigns/${data.campaignId}/suspend`, data).then(res => res.data);
 },
 confirmCompletion: data => {
  return client.post(`seller/placement/campaigns/${data.campaignId}/confirm-completion`, data).then(res => res.data);
 },
 getCampaignsInvoice: data => {
  return client.get(`seller/placement/campaigns/${data.campaignId}/invoice`, { params: data }).then(res => res.data);
 },
}